import { memo } from 'react';
import { cn } from '@/lib/utils';
import { IAccountStatusBadgeProps } from '@/@types/socialMedia';

/**
 * Badge showing account connection status
 */
const AccountStatusBadge = ({ status, className }: IAccountStatusBadgeProps) => {
  const statusConfig = {
    active: {
      label: 'Active',
      colorClass: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
    },
    expired: {
      label: 'Expired',
      colorClass: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
    },
    invalid: {
      label: 'Invalid',
      colorClass: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
    },
    reconnect_required: {
      label: 'Reconnect Required',
      colorClass: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
    },
  };

  const config = statusConfig[status];

  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
        config.colorClass,
        className
      )}
    >
      {config.label}
    </span>
  );
};

export const AccountStatusBadgeMemo = memo(AccountStatusBadge);
